module.exports = __webpack_public_path__ + "img/face-meh-blank.8ed3bf0e.svg";